// extracted by mini-css-extract-plugin
export default {"after-action-close-icon":"OpenIframe_after-action-close-icon_g9UVV","after-action-tips-page":"OpenIframe_after-action-tips-page_mtMmd"};